<template>
    <div class="margin-bottom-2">
        <dl v-if="content.code">
            <dt>{{getTranslation('code')}}</dt>
            <dd>{{content.code}}.00</dd>
        </dl>
        <dl v-if="content.birth">
            <dt>{{getTranslation('birth')}}</dt>
            <dd>{{content.birth}}</dd>
        </dl>
        <dl v-if="content.lives">
            <dt>{{getTranslation('lives')}}</dt>
            <dd>{{content.lives}}</dd>
        </dl>
        <dl v-if="content.www">
            <dt>{{getTranslation('website')}}</dt>
            <dd>{{content.www}}</dd>
        </dl>
        <dl v-if="content.map">
            <dt>{{getTranslation('map')}}</dt>
            <dd>{{content.map}}</dd>
        </dl>
        <dl v-if="content.exhibitions">
            <dt>{{getTranslation('exhibitions')}}</dt>
            <dd v-html="content.exhibitions"></dd>
        </dl>
        <dl v-if="content.performances">
            <dt>{{getTranslation('performances')}}</dt>
            <dd v-html="content.performances"></dd>
        </dl>
        <dl v-if="content.collaboration">
            <dt>{{getTranslation('collaboration')}}</dt>
            <dd v-html="content.collaboration"></dd>
        </dl>
    </div>
</template>

<script>
import mixinLanguages from '../mixins/Language'
export default {
  name: 'metaArtist',
  props: ['content'],
  mixins: [mixinLanguages],
  computed: {
    language() {
      return this.$store.state.language;
    },
  },
  watch: {
    
  },
  mounted() {
    this.$nextTick(function () {
      console.log('next tick');
      this.appLanguage = this.$store.state.language;
    })
  },
  data () {
   return {
        
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/MetaArtist.vue